var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3396 58.6114L3.42859 73.4686V7.67263C3.42859 6.54682 3.87582 5.46711 4.67189 4.67104C5.46796 3.87496 6.54767 3.42773 7.67349 3.42773H71.347C72.4728 3.42773 73.5525 3.87496 74.3486 4.67104C75.1446 5.46711 75.5919 6.54682 75.5919 7.67263V58.6114H22.3396ZM19.4021 50.1216H67.1021V11.9175H11.9184V56.0008L19.4021 50.1216ZM33.1429 67.1012H76.5979L84.0817 72.9804V28.8971H88.3266C89.4524 28.8971 90.5321 29.3444 91.3282 30.1404C92.1242 30.9365 92.5715 32.0162 92.5715 33.142V90.4481L73.6604 75.591H37.3878C36.262 75.591 35.1823 75.1438 34.3862 74.3477C33.5901 73.5516 33.1429 72.4719 33.1429 71.3461V67.1012Z",
    fill: "#242423",
    fillOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.585bdc7ec604c9979cb38a1dd62be4c5.svg";
export { ForwardRef as ReactComponent };